<template>
  <div>
    <b-modal
      id="modal-historico-reprocessamento"
      title="Histórico Completo"
      size="xl"
      scrollable
      @hidden="onModalClosed"
    >
      <div v-if="historicoData && historicoData.length > 0">
        <b-table
          :items="processedData"
          :fields="[
            { key: 'tipo_acao', label: 'TIPO DE AÇÃO' },
            { key: 'situacao_envio', label: 'SITUAÇÃO DE ENVIO' },
            { key: 'dados_enviados', label: 'DADOS ENVIADOS' },
            { key: 'dados_recebidos', label: 'DADOS RECEBIDOS' },
            { key: 'data_envio', label: 'DATA DE ENVIO' }
          ]"
          responsive
          striped
          hover
          class="historico-table"
          show-empty
          :busy="false"
          no-local-sorting
        >
          <template #cell(tipo_acao)="row">
            <span class="font-weight-bold">
              {{ row.item.tipo_acao }}
            </span>
          </template>

          <template #cell(situacao_envio)="row">
            <b-badge 
              :variant="getSituacaoVariant(row.item.situacao_envio)"
              class="font-weight-bold"
            >
              {{ row.item.situacao_envio || 'N/A' }}
            </b-badge>
          </template>

          <template #cell(dados_enviados)="row">
            <b-button
              v-if="row.item.dados_enviados && row.item.situacao_envio !== 'Interrompido'"
              size="sm"
              variant="outline-primary"
              @click="showJsonModal(row.item.dados_enviados)"
            >
              TXT JSON
            </b-button>
            <span v-else class="text-muted">N/A</span>
          </template>

          <template #cell(dados_recebidos)="row">
            <b-button
              v-if="row.item.situacao_envio !== 'Pendente' && row.item.situacao_envio !== 'Enviado' && row.item.situacao_envio !== 'Interrompido'"
              size="sm"
              variant="outline-primary"
              @click="showJsonModal(getDadosRecebidos(row.item))"
            >
              TXT JSON
            </b-button>
            <span v-else class="text-muted">N/A</span>
          </template>

          <template #cell(data_envio)="row">
            <span class="font-weight-bold">
              {{ formatDate(row.item.data_envio) }}
            </span>
          </template>

          <template #empty>
            <div class="text-center py-3">
              <p class="text-muted">Nenhum dado para exibir</p>
            </div>
          </template>
        </b-table>
      </div>

      <div v-else class="text-center py-4">
        <b-icon icon="info-circle" class="text-muted mb-2" font-scale="3"></b-icon>
        <p class="text-muted">Nenhum histórico disponível para este registro.</p>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" @click="onModalClosed">
          Fechar
        </b-button>
      </template>
    </b-modal>

    <JsonViewerModal
      :jsonData="currentJsonData"
      @closed="onJsonModalClosed"
      ref="jsonViewerModal"
    />
  </div>
</template>

<script>
import moment from 'moment';
import {
  BModal,
  BTable,
  BBadge,
  BButton,
  BIcon
} from 'bootstrap-vue';
import JsonViewerModal from './JsonViewerModal.vue';

export default {
  components: {
    BModal,
    BTable,
    BBadge,
    BButton,
    BIcon,
    JsonViewerModal
  },
  name: 'HistoricoReprocessamentoModal',
  
  props: {
    historicoData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      currentJsonData: null,
      tableFields: [
        { 
          key: 'tipo_acao', 
          label: 'TIPO DE AÇÃO', 
          sortable: true,
          class: 'text-center'
        },
        { 
          key: 'situacao_envio', 
          label: 'SITUAÇÃO DE ENVIO', 
          sortable: true,
          class: 'text-center'
        },
        { 
          key: 'dados_enviados', 
          label: 'DADOS ENVIADOS', 
          sortable: false
        },
        { 
          key: 'dados_recebidos', 
          label: 'DADOS RECEBIDOS', 
          sortable: false
        },
        { 
          key: 'data_envio', 
          label: 'DATA DE ENVIO', 
          sortable: true,
          class: 'text-center'
        }
      ]
    };
  },

  computed: {
    processedData() {
      if (!this.historicoData || !Array.isArray(this.historicoData)) {
        return [];
      }
      
      return this.historicoData.map(item => ({
        ...item,
        tipo_acao: item.tipo_acao,
        situacao_envio: item.situacao || 'N/A',
        dados_enviados: item.dados_enviados || 'N/A',
        dados_recebidos: null,
        data_envio: item.data_envio || 'N/A'
      }));
    }
  },

  methods: {

    getSituacaoVariant(situacao) {
      switch (situacao?.toLowerCase()) {
        case 'sucesso':
          return 'success';
        case 'erro':
          return 'danger';
        case 'pendente':
          return 'warning';
        case 'processando':
          return 'info';
        default:
          return 'secondary';
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      
      try {
        return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
      } catch (error) {
        return dateString;
      }
    },

    getDadosRecebidos(item) {
      if (item.situacao_envio === "Erro") {
        return {
            "status": "Erro",
            "mensagem": "Foram encontradas inconsistências durante o processamento",
            "inconsistencias": [ item.inconsistencia ]
          }
        }
        if(item.situacao_envio == "Sucesso"){
          return {
            "status": "Sucesso",
            "mensagem": "Registro processado com sucesso",
            "id_integracao": item.id_integracao 
          }
        } 
    },

    onModalClosed() {
      this.$emit('closed');
      this.$bvModal.hide('modal-historico-reprocessamento');
    },

    showJsonModal(jsonData) {
      this.currentJsonData = jsonData;
      this.$refs.jsonViewerModal.show();
    },

    onJsonModalClosed() {
      this.currentJsonData = null;
    }
  }
};
</script>

<style scoped>
.historico-table {
  font-size: 0.9rem;
}

.dados-container {
  max-width: 300px;
}

.dados-item {
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
}

.dados-item:last-child {
  margin-bottom: 0;
}

.dados-item strong {
  color: #495057;
  font-size: 0.8rem;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .dados-container {
    max-width: 200px;
  }
  
  .dados-item {
    font-size: 0.8rem;
  }
  
  .dados-item strong {
    font-size: 0.75rem;
  }
}
</style>
